import { createRoute } from "@tanstack/react-router";
import { workspaceRoute } from "../shell/routes";
import { MeetingNotesPage } from "./MeetingNotesPage";

/** A meeting's AI notes (WP-017), opened from the dashboard's meetings and the chat meeting chip. */
export const meetingNotesRoute = createRoute({
  getParentRoute: () => workspaceRoute,
  path: "meetings/$meetingId",
  component: function MeetingNotes() {
    const { workspaceId, meetingId } = meetingNotesRoute.useParams();
    return <MeetingNotesPage key={`${workspaceId}/${meetingId}`} workspaceId={workspaceId} meetingId={meetingId} />;
  },
});
